"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var BrowsingContext_1 = __importDefault(require("../../common/enums/BrowsingContext"));
var MenuListItem = function (props) {
    var children = props.children, classes = props.classes, href = props.href, selected = props.selected, onClick = props.onClick, target = props.target, otherProps = __rest(props, ["children", "classes", "href", "selected", "onClick", "target"]);
    var icon = (target === BrowsingContext_1.default.BLANK) ? react_1.default.createElement(Icon_1.default, { name: "open-in-new", classes: "fds-icon-inline" }) : null;
    return (react_1.default.createElement("li", __assign({ className: getClassNames(selected, classes) }, otherProps), href ? (react_1.default.createElement("a", { className: "fds-menulist-item-label", href: href, target: target, onClick: onClick },
        children,
        icon)) : (react_1.default.createElement("span", { className: "fds-menulist-item-label", onClick: onClick },
        children,
        icon))));
};
MenuListItem.defaultProps = {
    target: BrowsingContext_1.default.SELF
};
var getClassNames = function (selected, classes) {
    return classnames_1.default('fds-menulist-item', {
        'is-selected': selected
    }, classes);
};
exports.default = MenuListItem;
